import { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import {
  Table,
  Card,
  Row,
  Spin,
  Col,
  Button
} from 'antd';
import iliskiliBasvuruGecmisSorgula from "../../services/iliskiliBasvuruGecmisSorgula";
import { errorMessage } from "../Helpers/Util";
import ExcelExport from './../ExcelExport';
import { FileExcelOutlined, OrderedListOutlined } from "@ant-design/icons";

const parsed = queryString.parse(history.location.search);

const IliskiliBasvuruGecmisiForm = () => {
  const [spining, setSpining] = useState(false);
  const [historyList, setHistoryList] = useState([]);
  const parentObjectId = parseInt(parsed.parentObjectId);

  const load = async () => {
    setSpining(true);

    await iliskiliBasvuruGecmisSorgula(parentObjectId).then(async res => {
      if (res.data.success) {
        var respData = res.data.result;
        
        await respData.map(async d => {
          var data = {
            data : d.BasvuruEvents,
            name : d. AltSurecAdi,
            key : d. AltSurecTipiId,
            keyTitles: opKeyTitles
          };
          await setHistoryList(history => [...history, data]);
        });
      } else {
        errorMessage(res.data.message)
      }
    }).catch(err => {
      errorMessage(err.message)
    });
    setSpining(false);
  }
  useEffect(() => {
    load()
  }, []);

  const columns = [
    {
      title: 'Başvuru No',
      dataIndex: 'BasvuruNo',
      key: 'BasvuruNo',
    },
    {
      title: 'Ada/Parsel',
      dataIndex: 'AdaParsel',
      key: 'AdaParsel',
    },
    {
      title: 'İşlemi Yapan',
      dataIndex: 'Kullanici',
      key: 'Kullanici',
    },
    {
      title: 'Olay',
      dataIndex: 'OlayAciklamasi',
      key: 'OlayAciklamasi',
    }, {
      title: 'Durum',
      dataIndex: 'Durum',
      key: 'Durum',
    }, {
      title: 'Tarih',
      dataIndex: 'Tarih',
      key: 'Tarih',
    }, {
      title: 'Açıklama',
      dataIndex: 'Aciklama',
      key: 'Aciklama',
    }
  ];

  let opKeyTitles = columns.map(items => { return { key: items.key, title: items.title } });

  return (
  <Spin tip={"Veriler Yükleniyor"}
    spinning={spining}>
    <Card style={{ margin: "20px" }} title={<h4 style={{
            fontWeight: "bolder",
            color: "white"
          }}> Tüm Süreç Geçmişi</h4>}
      className="ant-card-head-title-large">
        <div style={{textAlign : 'right'}}>
          <ExcelExport
          fileName={'Tüm Süreç Geçmişi'}
          downloadButton={<Button type="link" icon={<FileExcelOutlined style={{ color: "green" }} />}> Excele Aktar </Button>}
          sheets={historyList}  />
        </div>
      
       {historyList.map(resp => (
            <Card>
             <Table   
              title={() => <p style={{padding: "10",fontWeight: "bold"}}>  {resp.name } </p> }
              columns={columns}
              dataSource={resp.data}              
              pagination={false} 
              rowKey={"key"}   
              scroll={{ y: 750 }}
            />   
           </Card>

       ))}
     
    </Card >
  </Spin>
  );

}
export default IliskiliBasvuruGecmisiForm;
